export const AccordianData = [
  {
    Accordionkey: 1,
    title: 'Are ACKO Standard Health Insurance and Aarogya Sanjeevani insurance the same plans?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img1.png',
  },
  {
    Accordionkey: 2,
    title: 'Can I buy the plan online?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img2.png',
  },
  {
    Accordionkey: 3,
    title: 'Are pre-existing conditions covered in this plan?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img1.png',
  },
  {
    Accordionkey: 4,
    title: 'How is the premium for ACKO Standard Health Insurance calculated?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img2.png',
  },
  {
    Accordionkey: 5,
    title: 'Which riders are included with ACKO Standard Health Insurance?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img1.png',
  },
  {
    Accordionkey: 6,
    title: 'Which insurers are included with ACKO Standard Health Insurance?',
    content:
      'Your first action to initiate a claim is to either log in to your ACKO account or contact us at 1800-266-2256',
    image: '/images/accordion-img2.png',
  },
]

export const AccordionStrapiResponseWithoutImage = {
  data: {
    id: 2,
    attributes: {
      sectionHeading:
        '<h2>Most popular myths about medical insurance</h2><p>Here is a list of the three most popular medical insurance myths that some people believe are true. But in reality, they are just myths and should not be considered to be true.</p>',
      createdAt: '2024-02-12T04:23:31.120Z',
      updatedAt: '2024-02-12T04:23:31.120Z',
      publishedAt: null,
      hasTabs: true,
      accordionCards: [
        {
          id: 5,
          accordionType: 'WithoutImage',
          accordionContent:
            '<p>Some people prefer buying medical insurance schemes using the traditional method—through intermediaries or by visiting an insurance company, as they might distrust online insurers. However, each insurance company (whether online or offline) must be registered with the Insurance Regulatory and Development Authority of India (IRDAI). You must cross-check their registration number on the IRDAI website before purchasing insurance. By the way, ACKO’s IRDAI registration number is 157!</p>',
          tabSection: 'Myths',
          accordionHeading: 'Myth 1: Online mediclaim policy in India is a scam',
          accordionImage: {
            data: null,
          },
        },
        {
          id: 6,
          accordionType: 'WithoutImage',
          accordionContent:
            '<p>Some people prefer paying Hospital Bills using the traditional method—through intermediaries or by visiting an insurance company, as they might distrust online insurers. However, each insurance company (whether online or offline) must be registered with the Insurance Regulatory and Development Authority of India (IRDAI). You must cross check their registration number on the IRDAI website before purchasing insurance. By the way, ACKO’s IRDAI registration number is 157!</p>',
          tabSection: 'Myths',
          accordionHeading: 'Myth 2: I need to pay the hospital bill for treating a pre-existing disease',
          accordionImage: {
            data: null,
          },
        },
        {
          id: 7,
          accordionType: 'WithoutImage',
          accordionContent:
            '<p>Some people prefer buying medical insurance schemes using the traditional method—through intermediaries or by visiting an insurance company, as they might distrust online insurers. However, each insurance company (whether online or offline) must be registered with the Insurance Regulatory and Development Authority of India (IRDAI). You must cross check their registration number on the IRDAI website before purchasing insurance. By the way, ACKO’s IRDAI registration number is 157!</p>',
          tabSection: 'Myths',
          accordionHeading: 'Myth 3: I can only claim if I was hospitalised',
          accordionImage: {
            data: null,
          },
        },
        {
          id: 8,
          accordionType: 'WithoutImage',
          accordionContent:
            "<p>Health insurance claims are requests you make to your insurance company to cover the costs of medical treatments. Remember that you can only claim against things that are covered in your insurance plan. So it's very important that you know what is covered and what is not.</p>",
          tabSection: 'Facts',
          accordionHeading: 'Are ACKO Standard Health Insurance and Aarogya Sanjeevani insurance the same plans?',
          accordionImage: {
            data: null,
          },
        },
        {
          id: 9,
          accordionType: 'WithoutImage',
          accordionContent:
            '<p>Usually, there are two ways in which you can claim.</p><ul><li>Cashless claim</li><li>Reimbursement claim.</li></ul><p>&nbsp;</p><p>In a cashless claim, the insurer will pay the hospital bill. In a reimbursement claim you first pay the bill, and then raise a claim to get back the money you paid.</p>',
          tabSection: 'Facts',
          accordionHeading: 'What are health insurance claims?',
          accordionImage: {
            data: null,
          },
        },
        {
          id: 10,
          accordionType: 'WithoutImage',
          accordionContent:
            "<p>Health insurance claims are requests you make to your insurance company to cover the costs of medical treatments. Remember that you can only claim against things that are covered in your insurance plan. So it's very important that you know what is covered and what is not.</p>",
          tabSection: 'Facts',
          accordionHeading: 'How to raise a claim against your ACKO Platinum Health Insurance Policy?',
          accordionImage: {
            data: null,
          },
        },
      ],
    },
  },
  meta: {},
}

export const AccordionStrapiResponseWithImage = {
  data: {
    id: 3,
    attributes: {
      sectionHeading:
        '<h2>What are the factors that influence health insurance premium calculation?</h2><p>Here are the factors that influence health insurance premium calculation.</p>',
      createdAt: '2024-02-12T11:16:32.534Z',
      updatedAt: '2024-02-12T11:16:32.534Z',
      publishedAt: null,
      hasTabs: false,
      accordionCards: [
        {
          id: 12,
          accordionType: 'WithImage',
          accordionContent:
            '<p>Ah, the age factor! It plays a role in determining the full health insurance coverage cost for your ACKO Platinum Insurance Plan. As you might expect, the older you are, the higher the medical insurance premium.</p>',
          tabSection: null,
          accordionHeading: 'Age',
          accordionImage: {
            data: {
              id: 1,
              attributes: {
                name: 'relatedArticles1.png',
                alternativeText: null,
                caption: null,
                width: 714,
                height: 448,
                formats: {
                  small: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/small_related_Articles1_59969443a0.png',
                    hash: 'small_related_Articles1_59969443a0',
                    mime: 'image/png',
                    name: 'small_relatedArticles1.png',
                    path: null,
                    size: 190.91,
                    width: 500,
                    height: 314,
                  },
                  thumbnail: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/thumbnail_related_Articles1_59969443a0.png',
                    hash: 'thumbnail_related_Articles1_59969443a0',
                    mime: 'image/png',
                    name: 'thumbnail_relatedArticles1.png',
                    path: null,
                    size: 52.91,
                    width: 245,
                    height: 154,
                  },
                },
                hash: 'related_Articles1_59969443a0',
                ext: '.png',
                mime: 'image/png',
                size: 119.37,
                url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/related_Articles1_59969443a0.png',
                previewUrl: null,
                provider: 'aws-s3',
                provider_metadata: null,
                createdAt: '2024-02-12T11:12:59.175Z',
                updatedAt: '2024-02-12T11:12:59.175Z',
              },
            },
          },
        },
        {
          id: 11,
          accordionType: 'WithImage',
          accordionContent:
            '<p>Decide how many individuals you wish to insure, how much coverage you need, and which add-ons you want to buy.</p>',
          tabSection: null,
          accordionHeading: 'Sum insured',
          accordionImage: {
            data: {
              id: 3,
              attributes: {
                name: 'relatedArticles2.png',
                alternativeText: null,
                caption: null,
                width: 714,
                height: 448,
                formats: {
                  small: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/small_related_Articles2_03f134aa39.png',
                    hash: 'small_related_Articles2_03f134aa39',
                    mime: 'image/png',
                    name: 'small_relatedArticles2.png',
                    path: null,
                    size: 137.95,
                    width: 500,
                    height: 314,
                  },
                  thumbnail: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/thumbnail_related_Articles2_03f134aa39.png',
                    hash: 'thumbnail_related_Articles2_03f134aa39',
                    mime: 'image/png',
                    name: 'thumbnail_relatedArticles2.png',
                    path: null,
                    size: 41.97,
                    width: 245,
                    height: 154,
                  },
                },
                hash: 'related_Articles2_03f134aa39',
                ext: '.png',
                mime: 'image/png',
                size: 54.12,
                url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/related_Articles2_03f134aa39.png',
                previewUrl: null,
                provider: 'aws-s3',
                provider_metadata: null,
                createdAt: '2024-02-12T11:13:10.474Z',
                updatedAt: '2024-02-12T11:13:10.474Z',
              },
            },
          },
        },
        {
          id: 13,
          accordionType: 'WithImage',
          accordionContent:
            '<p>Select the coverage and click "calculate" to view the payable medical insurance premium for the chosen cover.</p>',
          tabSection: null,
          accordionHeading: 'Number of insured members',
          accordionImage: {
            data: {
              id: 2,
              attributes: {
                name: 'relatedArticles3.png',
                alternativeText: null,
                caption: null,
                width: 714,
                height: 448,
                formats: {
                  small: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/small_related_Articles3_359b4b9e0c.png',
                    hash: 'small_related_Articles3_359b4b9e0c',
                    mime: 'image/png',
                    name: 'small_relatedArticles3.png',
                    path: null,
                    size: 148.81,
                    width: 500,
                    height: 314,
                  },
                  thumbnail: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/thumbnail_related_Articles3_359b4b9e0c.png',
                    hash: 'thumbnail_related_Articles3_359b4b9e0c',
                    mime: 'image/png',
                    name: 'thumbnail_relatedArticles3.png',
                    path: null,
                    size: 46.18,
                    width: 245,
                    height: 154,
                  },
                },
                hash: 'related_Articles3_359b4b9e0c',
                ext: '.png',
                mime: 'image/png',
                size: 73.14,
                url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/related_Articles3_359b4b9e0c.png',
                previewUrl: null,
                provider: 'aws-s3',
                provider_metadata: null,
                createdAt: '2024-02-12T11:13:10.372Z',
                updatedAt: '2024-02-12T11:13:10.372Z',
              },
            },
          },
        },
        {
          id: 14,
          accordionType: 'WithImage',
          accordionContent:
            "<p>You know what's awesome about being in your 20s? Generally, you tend to have fewer health issues compared to thirty-somethings. That means your chances of getting comprehensive coverage are higher, with little or no pre-existing conditions to worry about when you buy medical policy. It's like a head start on securing a solid insurance.</p>",
          tabSection: null,
          accordionHeading: 'Location',
          accordionImage: {
            data: {
              id: 4,
              attributes: {
                name: 'accordion-img2.png',
                alternativeText: null,
                caption: null,
                width: 548,
                height: 610,
                formats: {
                  small: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/small_accordion_img2_ed01fe693c.png',
                    hash: 'small_accordion_img2_ed01fe693c',
                    mime: 'image/png',
                    name: 'small_accordion-img2.png',
                    path: null,
                    size: 411.8,
                    width: 449,
                    height: 500,
                  },
                  thumbnail: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/thumbnail_accordion_img2_ed01fe693c.png',
                    hash: 'thumbnail_accordion_img2_ed01fe693c',
                    mime: 'image/png',
                    name: 'thumbnail_accordion-img2.png',
                    path: null,
                    size: 53.83,
                    width: 140,
                    height: 156,
                  },
                },
                hash: 'accordion_img2_ed01fe693c',
                ext: '.png',
                mime: 'image/png',
                size: 134.35,
                url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/accordion_img2_ed01fe693c.png',
                previewUrl: null,
                provider: 'aws-s3',
                provider_metadata: null,
                createdAt: '2024-02-12T11:15:30.543Z',
                updatedAt: '2024-02-12T11:15:30.543Z',
              },
            },
          },
        },
        {
          id: 15,
          accordionType: 'WithImage',
          accordionContent:
            "<p>No hidden surprises here! Buying health insurance online gives you the gift of transparency. You can easily access all the nitty-gritty details of the policy, like coverage limits, exclusions, and benefits. It's all right there on our website for you to see and review. So, you can make an informed decision without any guesswork. Transparency is key!</p>",
          tabSection: null,
          accordionHeading: 'Medical status',
          accordionImage: {
            data: {
              id: 5,
              attributes: {
                name: 'image 262.png',
                alternativeText: null,
                caption: null,
                width: 936,
                height: 600,
                formats: {
                  small: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/small_image_262_14d5472f63.png',
                    hash: 'small_image_262_14d5472f63',
                    mime: 'image/png',
                    name: 'small_image 262.png',
                    path: null,
                    size: 243.97,
                    width: 500,
                    height: 321,
                  },
                  medium: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/medium_image_262_14d5472f63.png',
                    hash: 'medium_image_262_14d5472f63',
                    mime: 'image/png',
                    name: 'medium_image 262.png',
                    path: null,
                    size: 515.14,
                    width: 750,
                    height: 481,
                  },
                  thumbnail: {
                    ext: '.png',
                    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/thumbnail_image_262_14d5472f63.png',
                    hash: 'thumbnail_image_262_14d5472f63',
                    mime: 'image/png',
                    name: 'thumbnail_image 262.png',
                    path: null,
                    size: 68.27,
                    width: 243,
                    height: 156,
                  },
                },
                hash: 'image_262_14d5472f63',
                ext: '.png',
                mime: 'image/png',
                size: 162.42,
                url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/image_262_14d5472f63.png',
                previewUrl: null,
                provider: 'aws-s3',
                provider_metadata: null,
                createdAt: '2024-02-12T11:16:20.382Z',
                updatedAt: '2024-02-12T11:16:20.382Z',
              },
            },
          },
        },
      ],
    },
  },
  meta: {},
}

export const evaluateAccordionType = response => {
  const firstCard = response?.data?.attributes?.accordionCards?.[0]
  const inputType = firstCard?.accordionType === 'WithoutImage' ? 'checkbox' : 'radio'
  const withImage = firstCard?.accordionType !== 'WithoutImage'

  return {
    inputType,
    withImage,
    AccordionContent: firstCard?.AccordionContent,
  }
}
